function priceFormatter({ price }) {
    return new Intl.NumberFormat("nl", { style: "currency", currency: "EUR" }).format(price);
}

export default priceFormatter;
